import { useEffect, useState } from 'react';

/** Telefon = szerokość < 768 px (punkt `md` Tailwinda). */
export const PHONE_QUERY = '(max-width: 767px)';

function matches(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}

/**
 * Czy pasuje zapytanie o media (np. `(max-width: 1023px)`). Dla elementów, które na węższym ekranie są INNE, a nie
 * tylko inaczej ułożone — wtedy w drzewie jest jedna wersja (bez dwóch chipów klienta albo dwóch pól „Klient” naraz).
 * Zapytania pisz „od wąskiego” (`max-width`): testy jednostkowe w jsdom (matchMedia = false) widzą wersję desktopową.
 */
export function useMediaQuery(query: string): boolean {
  const [value, setValue] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const on = () => setValue(mq.matches);
    on();
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, [query]);
  return value;
}

/**
 * Czy ekran to telefon (< 768 px). Dla elementów, które na telefonie są INNE (pływająca główna akcja, „Filtry”
 * w dolnym panelu), a nie tylko inaczej ułożone. Sam układ — klasami `max-md:` / `md:`.
 */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_QUERY);
}
